exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntextarea[data-v-66962b71] {\n  height: 5rem;\n  resize: none;\n}\n.card-btn[data-v-66962b71] {\n  float: right;\n  position: relative;\n  margin-top: -10px;\n  top: 5px;\n}\n.informations[data-v-66962b71] {\n  padding-bottom: 1.5rem;\n  padding-top: 1.5rem;\n}\n.informations h5[data-v-66962b71] {\n  margin-bottom: 1rem;\n}\n.left[data-v-66962b71] {\n  height: 100%;\n  max-height: 800px;\n  max-width: 100%;\n  overflow-y: auto;\n}\n.right[data-v-66962b71] {\n  max-height: 600px;\n}\n.treeview[data-v-66962b71] {\n  border-right: 1px solid #eee;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-66962b71","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/Evaluation.vue
// module id = 7IfF
// module chunks = 70